<div class="modal-backdrop">
  <div class="modal-container">
    <div class="modal">
      <div class="modal-header">
        <h3 class="modal-title">Detalhes do Pacote: {{ data.package.name }}</h3>
      </div>

      <mat-dialog-content class="modal-body">
        <div class="package-details">
          <!-- Informações do Pacote -->
          <div class="info-section">
            <div class="title-section">Informações Gerais</div>
            
            <div class="info-row">
              <span class="info-label">ID:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ data.package.id }}</span>
            </div>
            
            <div class="info-row">
              <span class="info-label">Tipo:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ data.package.packageType }}</span>
            </div>
            
            <div class="info-row">
              <span class="info-label">Descrição:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ data.package.description || '—' }}</span>
            </div>
            
            <div class="info-row">
              <span class="info-label">Status:</span>
              <span class="info-separator"></span>
              <span class="badge" [ngClass]="data.package.active ? 'badge-success' : 'badge-error'">
                {{ data.package.active ? 'Ativo' : 'Inativo' }}
              </span>
            </div>
            
            <div class="info-row">
              <span class="info-label">Criado em:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ formatDate(data.package.createdAt) }}</span>
            </div>
          </div>

          <!-- Total do Pacote -->
          <div class="card card-dark total-section">
            <div class="total-content">
              <div>
                <strong>Valor Total do Pacote</strong>
                <p>Inclui todos os itens e descontos aplicados</p>
              </div>
              <div class="total-value">
                {{ formatPrice(data.packageTotal) }}
              </div>
            </div>
          </div>

          <mat-divider></mat-divider>

          <!-- ITENS DO PACOTE -->
          <div class="items-section">
            <div class="title-section">Itens do Pacote ({{ getItemsCount() }})</div>

            <div *ngIf="data.package.items && data.package.items.length > 0; else noItems">
              <table mat-table [dataSource]="data.package.items" class="items-table">
                <ng-container matColumnDef="product">
                  <th mat-header-cell *matHeaderCellDef>Produto</th>
                  <td mat-cell *matCellDef="let item">ID: {{ item.product.id }} - {{ item.product.name }}</td>
                </ng-container>

                <ng-container matColumnDef="quantity">
                  <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                  <td mat-cell *matCellDef="let item">{{ item.quantity }}</td>
                </ng-container>

                <ng-container matColumnDef="basePrice">
                  <th mat-header-cell *matHeaderCellDef>Preço Base</th>
                  <td mat-cell *matCellDef="let item">{{ formatPrice(item.product.basePrice) }}</td>
                </ng-container>

                <ng-container matColumnDef="finalPrice">
                  <th mat-header-cell *matHeaderCellDef>Preço Final</th>
                  <td mat-cell *matCellDef="let item">{{ formatPrice(item.finalPrice) }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['product','quantity','basePrice','finalPrice']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['product','quantity','basePrice','finalPrice'];"></tr>
              </table>
            </div>

            <ng-template #noItems>
              <p class="empty-message">Nenhum item adicionado</p>
            </ng-template>
          </div>

          <mat-divider></mat-divider>

          <!-- DESCONTOS DO PACOTE -->
          <div class="discounts-section">
            <div class="title-section">Descontos ({{ getDiscountsCount() }})</div>

            <div *ngIf="data.package.discounts && data.package.discounts.length > 0; else noDiscounts">
              <div class="discounts-list">
                <div class="card discount-card" *ngFor="let discount of data.package.discounts">
                  <div class="discount-header">
                    <strong>{{ discount.description }}</strong>
                    <span class="badge" [ngClass]="discount.active ? 'badge-primary' : 'badge-error'">
                      {{ discount.active ? 'Ativo' : 'Inativo' }}
                    </span>
                  </div>

                  <div class="discount-details">
                    <div class="detail-item">
                      <small>Tipo:</small>
                      <p>{{ getDiscountTypeLabel(discount.type) }}</p>
                    </div>

                    <div *ngIf="discount.type === 'PERCENTAGE' && getDiscountPercentage(discount) !== null"
                      class="detail-item">
                      <small>Porcentagem:</small>
                      <p class="highlight">{{ (getDiscountPercentage(discount)! * 100).toFixed(2) }}%</p>
                    </div>

                    <div *ngIf="discount.type === 'FIXED' && getDiscountAmount(discount) !== null"
                      class="detail-item">
                      <small>Valor do Desconto:</small>
                      <p class="highlight">{{ formatPrice(getDiscountAmount(discount)!) }}</p>
                    </div>

                    <div class="detail-item">
                      <small>ID:</small>
                      <p>{{ discount.id }}</p>
                    </div>

                    <div class="detail-item">
                      <small>Criado em:</small>
                      <p>{{ formatDate(discount.createdAt) }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ng-template #noDiscounts>
              <p class="empty-message">Nenhum desconto adicionado</p>
            </ng-template>
          </div>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions class="modal-footer">
        <button mat-stroked-button (click)="onClose()" class="btn btn-ghost">
          <mat-icon>close</mat-icon>
          Fechar
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
